import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'

import { SubtlePushIcon } from '@arcade/web/icons/react'
import { Buttonless, Flex, PaddingInset, spacing, Stack, Text } from '@cash-design-system/react'
import { FormBlockerElementSectionHeaderElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { useTextTokenizer } from '@cash-web/shared-feature-use-text-tokenizer'
import { useFlowContext } from '@cash-web/shared-flow-data-access-context'

const ActionButton = styled(Buttonless)`
  width: unset;
  min-height: unset;
`

export const SectionHeaderElement = ({ title, body, show_more_action }: FormBlockerElementSectionHeaderElement) => {
  const textTokenizer = useTextTokenizer()

  const flow = useFlowContext()
  const { t } = useTranslation()

  return (
    <PaddingInset>
      <Stack space={spacing.s}>
        <Flex justifyContent="space-between" alignItems="center">
          <Text typography="sectionTitle" color="textStandard">
            {title}
          </Text>
          {show_more_action && (
            <ActionButton
              onClick={() => flow.executeBlockerAction(show_more_action)}
              aria-label={t('Show more button', { context: 'button label for show more action' })}
            >
              <Flex alignItems="center">
                <Text typography="bodyMedium">{show_more_action.text}</Text>
                <SubtlePushIcon size={16} />
              </Flex>
            </ActionButton>
          )}
        </Flex>
        {body && (
          <Text typography="body" color="textSubtle">
            {textTokenizer(body)}
          </Text>
        )}
      </Stack>
    </PaddingInset>
  )
}
